import React, { useState } from 'react';

import type { ExternalIntegration as ExternalIntegrationType } from 'App/components/hooks/integrations/externalIntegrationTypes';
import BemClass from '@upsales/components/Utils/bemClass';
import { Block, Card, Icon, Flex, Text } from '@upsales/components';
import './ExternalIntegration.scss';

type ExternalIntegrationProps = {
	integration: ExternalIntegrationType;
	onClick?: (integration: ExternalIntegrationType) => void;
	enabled?: boolean;
};

const ExternalIntegration = ({ integration, onClick, enabled }: ExternalIntegrationProps) => {
	const classes = new BemClass('ExternalIntegration');
	const [logoSrc, setLogoSrc] = useState(integration.icon);
	const spacing = 'ptm pbm pll prl';

	return (
		<Card className={classes.b()} onClick={onClick ? () => onClick(integration) : undefined}>
			<Flex className={classes.elem('content').b()} direction="column" justifyContent="space-between">
				<Block className={classes.elem('logoContainer').b()}>
					<img
						className={classes.elem('logo').b()}
						src={logoSrc}
						alt={integration.name}
						onError={() => setLogoSrc('img/startups.svg')}
					/>
				</Block>

				<Flex className={classes.elem('footer').b()} justifyContent="space-between">
					<Flex direction="column">
						<Flex className={classes.elem('shortDescription').b()} justifyContent="space-between">
							<Flex alignItems="center" space={spacing}>
								<Text size="md">{integration.name}</Text>
							</Flex>
						</Flex>
						<Flex className={classes.elem('longDescription').b()}>
							<Text space="pbm pll prl" size="sm" className={classes.elem('longDescriptionText').b()}>
								{integration.configs[0]?.values?.description}
							</Text>
						</Flex>
					</Flex>

					{enabled ? (
						<Flex className={classes.elem('enabled').b()}>
							<Block backgroundColor="super-light-green" space={spacing}>
								<Icon name="check" color="green" />
							</Block>
						</Flex>
					) : null}
				</Flex>
			</Flex>
		</Card>
	);
};

export default ExternalIntegration;
